module.exports = __webpack_public_path__ + "media/images/categories/carousel/banking-and-finance-8524c1b51964ce533eff999895625b92.jpg";